export function createPriceFreezeRequest({
  formData,
  offer,
  paxType,
  shoppingBasketId,
  repricing,
}) {
  return {
    itineraryPriceFreeze: itineraryPriceFreezeRequest(
      formData,
      offer,
      paxType,
      repricing
    ),
    contactDetails: contactDetails(formData),
    shoppingBasketId,
  };
}

function itineraryPriceFreezeRequest(
  formData = {},
  offer = {},
  paxType = {},
  repricing = {}
) {
  return {
    offerId: offer.id,
    buyerEmail: formData.email,
    pax: [
      {
        personalInfo: {
          name: formData.name,
          firstLastName: formData.surname,
          ageType: paxType,
        },
        contactDetails: contactDetails(formData),
      },
    ],
    repricing: {
      totalPriceDifference: totalPriceDifference(repricing, offer),
    },
  };
}

function contactDetails(formData) {
  return {
    email: formData.email,
    phone: {
      countryCode:
        formData.country_code.indexOf('+') >= 0
          ? formData.country_code
          : '+' + formData.country_code,
      number: formData.phone,
    },
  };
}

function totalPriceDifference(repricing, offer) {
  return typeof repricing.difference?.amount === 'number'
    ? {
        amount: repricing.difference?.amount,
        currency: offer.deposit?.currency,
      }
    : null;
}
